export enum blobTypes {
  pdf = "application/pdf",
  csv = "text/csv",
}
